/* istanbul ignore file */

import OneAuth from "./OneAuth";
export default OneAuth;